// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { status } from "../types/status";
import { assessmentUsage } from "../types/assessmentUsage";
import { assessmentFormLanguage } from "../types/assessmentFormLanguage";
import { assessmentFormItem } from "../types/assessmentFormItem";
import {assessmentAnswerOption} from "../types/assessmentAnswerOption";
import { assessmentExport } from "../types/assessmentExport";

const envSettings = window as any;

// Define a service using a base URL and expected endpoints
export const assessmentManagementApi = createApi({
	reducerPath: "assessmentManagementApi",
	tagTypes: ["assessmentManagement"],
	baseQuery: fetchBaseQuery({
		baseUrl: envSettings.REACT_APP_CCL_API_MANAGEMENT_URL,
		prepareHeaders: (headers, { getState }) => {
			const token = sessionStorage.getItem("token") as string;
			headers.set("authorization", `Bearer ${token}`);
			return headers;
		},
	}),
	endpoints: (builder) => ({
		getStatus: builder.query<status, void>({
			query: () => ({
				url: `/assessments2-api/api/status`,
				method: "GET",
			}),
		}),
		getAssessmentUsage: builder.query<assessmentUsage[], void>({
			query: () => ({
				url: `/assessments2-api/assessment-management/assessment-usage`,
				method: "GET",
			}),
		}),
		getAssessmentFormLanguages: builder.query<assessmentFormLanguage[], number>(
			{
				query: (id) => ({
					url: `/assessments2-api/assessment-management/assessment-form-languages/${id}`,
					method: "GET",
				}),
			}
		),
		getAssessmentFormItems: builder.query<assessmentFormItem[], number>({
			query: (id) => ({
				url: `/assessments2-api/assessment-management/form-items/${id}`,
				method: "GET",
			}),
		}),
		getAssessmentAnswerOptions: builder.query<assessmentAnswerOption[], number>(
			{
                query: (id) => ({
                    url: `/assessments2-api/assessment-management/answer-options/${id}`,
                    method: "GET",
                }),
			}
		),
		getTemplate: builder.query<string, assessmentExport>(
			{
				query(data) {
					const { formMasterKey, exportType } = data;

					return {
						url: `/assessments2-api/assessment-management/assessment-template/${formMasterKey}/${exportType}`,
						method: "GET",
						responseHandler: (response) => response.text(),
					};
				},
			}
		)
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetStatusQuery,
    useGetAssessmentUsageQuery,
    useGetAssessmentFormLanguagesQuery,
    useGetAssessmentFormItemsQuery,
    useGetAssessmentAnswerOptionsQuery,
	useLazyGetTemplateQuery
} = assessmentManagementApi;
